angular.module('unergie.main')
.controller('createConsumptionDriftReportModalCtrl', ($scope, $uibModalInstance, $timeout, ApiUser, DataAccess, DataAccessSearch, BoFeaturesService, AlertManager, ErrorCatcher) => {
    $scope.consumptionDriftReportTypes = [
        { label: 'C5', value: 'C5' },
        // { label: 'C2C3', value: 'C2C3' },
        // { label: 'C4', value: 'C4' },
    ]

    $scope.duration = null
    $scope.durations = [
        { label: 'Dernier mois calendaire', value: 1 },
        { label: '3 derniers mois calendaires', value: 3 },
        { label: '6 derniers mois calendaires', value: 6 },
        { label: '12 derniers mois calendaires', value: 12 },
    ]

    $scope.consumptionDriftReportPayload = {
        type: $scope.consumptionDriftReportTypes[0].value,
        end_date: moment().startOf('month').format('YYYY-MM-DD'),
    }

    $scope.computeDates = () => {
        $scope.consumptionDriftReportPayload.start_date = moment().add(-$scope.duration, 'month').startOf('month').format('YYYY-MM-DD')
    }


    $scope.selectAccount = (account) => {
        $scope.consumptionDriftReportPayload.id_account = account && account.id
    }

    $scope.fetchAccountsForOrg = (org) => {
        if (!org) {
            return
        }
        $scope.consumptionDriftReportPayload.organization = org.id
        $scope.fetchingAccounts = true
        return DataAccess.myAccounts({ organization: org.id, light: true }).$promise
        .then((accounts) => {
            $scope.accounts = accounts
            if ($scope.accounts.length === 1) {
                $scope.selectAccount($scope.accounts[0])
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingAccounts = false
        })
    }

    const activate = () => {
        $scope.fetchingOrgz = true
        return DataAccess.myOrganizations().$promise
        .then((myOrganizations) => {
            $scope.organizations = _.orderBy(_.filter(myOrganizations, (org) => ['B2G', 'B2B'].includes(org.type)), 'id')
            if ($scope.organizations.length === 1) {
                $scope.fetchAccountsForOrg($scope.organizations[0])
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $timeout(() => {
                $scope.fetchingOrgz = false
            })
        })
    }

    $scope.createConsumptionDriftReport = () => {
        const payload = _.omit($scope.consumptionDriftReportPayload, ['type'])
        $scope.generating = true
        return ApiUser.createConsumptionDriftReport({ type: $scope.consumptionDriftReportPayload.type }, payload).$promise
        .then((result) => {
            AlertManager.success('Création lancée, vous recevrez un email lorsque la génération sera terminée.')
            $uibModalInstance.close()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.generating = false
        })
    }

    $scope.canGenerate = () => {
        return $scope.consumptionDriftReportPayload.type &&
            $scope.consumptionDriftReportPayload.organization &&
            $scope.consumptionDriftReportPayload.id_account &&
            $scope.consumptionDriftReportPayload.start_date &&
            $scope.consumptionDriftReportPayload.end_date
    }

    activate()

    $scope.close = () => $uibModalInstance.dismiss()
})
